__turbopack_context__.v({
  "rangeLabel": "size-module-scss-module__4Ezk0q__rangeLabel",
  "rangeRow": "size-module-scss-module__4Ezk0q__rangeRow",
  "separator": "size-module-scss-module__4Ezk0q__separator",
});
